import i18n from '@dms/i18n';

import {RentalVehicle} from '../../core/types/RentalVehicle';
import {Field} from './primitives/Field';

export function RentalAvailabilityMileageLimit() {
  return (
    <Field<RentalVehicle, 'number'>
      type="number"
      name="rentalProperties.availability.mileageLimit"
      suffix="Km"
      label={i18n.t('entity.rental.labels.mileageLimit')}
    />
  );
}
